import { render } from "./ProgressDialog.vue?vue&type=template&id=196b3489&scoped=true"
import script from "./ProgressDialog.vue?vue&type=script&lang=js"
export * from "./ProgressDialog.vue?vue&type=script&lang=js"

import "./ProgressDialog.vue?vue&type=style&index=0&id=196b3489&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196b3489"]])

export default __exports__